import React, { useState, useEffect } from 'react';
import api from '../api/client';

export default function AuditLogs() {
  const [logs, setLogs] = useState([]);
  const [pagination, setPagination] = useState({});
  const [entityType, setEntityType] = useState('');
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);

  useEffect(() => { load(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entityType, page]);

  const load = async () => {
    try {
      const res = await api.get('/audit-logs', { params: { entity_type: entityType || undefined, page, limit: 30 } });
      setLogs(res.data.data.logs);
      setPagination(res.data.data.pagination);
    } catch { } finally { setLoading(false); }
  };

  return (
    <div>
      <h1 className="text-xl font-bold text-dark-800 mb-4">Audit Logs</h1>

      <div className="mb-4">
        <select value={entityType} onChange={(e) => { setEntityType(e.target.value); setPage(1); }}
          className="px-3 py-2 bg-white border border-dark-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-primary-500">
          <option value="">All Entities</option>
          <option value="auth">Auth</option>
          <option value="user">Users</option>
          <option value="contact">Contacts</option>
          <option value="wa_session">WA Sessions</option>
          <option value="conversation">Conversations</option>
          <option value="message">Messages</option>
          <option value="subscription">Subscriptions</option>
          <option value="invoice">Invoices</option>
        </select>
      </div>

      <div className="bg-white rounded-xl border border-dark-200 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 border-b border-dark-200">
              <tr>
                <th className="text-left px-4 py-3 font-medium text-dark-500">Time</th>
                <th className="text-left px-4 py-3 font-medium text-dark-500">User</th>
                <th className="text-left px-4 py-3 font-medium text-dark-500">Action</th>
                <th className="text-left px-4 py-3 font-medium text-dark-500 hidden sm:table-cell">Description</th>
                <th className="text-left px-4 py-3 font-medium text-dark-500 hidden md:table-cell">IP</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-dark-100">
              {loading ? (
                <tr><td colSpan={5} className="text-center py-8 text-dark-400">Loading...</td></tr>
              ) : logs.length === 0 ? (
                <tr><td colSpan={5} className="text-center py-8 text-dark-400">No logs found</td></tr>
              ) : logs.map((log) => (
                <tr key={log.id} className="hover:bg-gray-50">
                  <td className="px-4 py-3 text-dark-500 whitespace-nowrap">{new Date(log.created_at).toLocaleString()}</td>
                  <td className="px-4 py-3">{log.user_name || '-'}</td>
                  <td className="px-4 py-3">
                    <span className="px-2 py-0.5 bg-dark-100 rounded text-xs font-medium">{log.action_type}</span>
                    <span className="ml-1 text-xs text-dark-400">{log.entity_type}</span>
                  </td>
                  <td className="px-4 py-3 text-dark-500 hidden sm:table-cell">{log.description}</td>
                  <td className="px-4 py-3 text-dark-400 text-xs hidden md:table-cell">{log.ip_address}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {pagination.totalPages > 1 && (
          <div className="flex justify-between items-center px-4 py-3 border-t border-dark-200 text-sm text-dark-400">
            <span>Page {pagination.page} of {pagination.totalPages}</span>
            <div className="flex gap-2">
              <button disabled={page <= 1} onClick={() => setPage(page - 1)} className="px-3 py-1 border border-dark-200 rounded hover:bg-gray-50 disabled:opacity-50">Prev</button>
              <button disabled={page >= pagination.totalPages} onClick={() => setPage(page + 1)} className="px-3 py-1 border border-dark-200 rounded hover:bg-gray-50 disabled:opacity-50">Next</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
